import { Order } from 'common/types';
import { DOCUMENT_TYPE, ORDER_TYPE } from '../MetaStore/MetaStoreApi.types';

export const initialOrder: Partial<Order> = {
    documentTypeId: DOCUMENT_TYPE.ORDER,
    orderTypeId: ORDER_TYPE.ORDER,
    instructions: {
        special: '',
    },
    fulfillmentDistributionCenterId: 0,
    fulfillmentTo: '',
    fulfillmentToAddress: '',
    fulfillmentToCity: '',
    fulfillmentToPostalCode: '',
    fulfillmentToRegion: '',
    tradeTypeId: undefined,
    tradeSubTypeId: undefined,
    priorityId: undefined,
    statusId: undefined,
    contacts: [],
    extReferenceNumber1: '',
    extReferenceNumber2: '',
    extPoNumber: '',
    lineItems: [],
    job: {} as Order['job'],
    opsJobManager: '',
    contractorId: undefined,
    hasFulfillmentMethods: false,
    fulfillmentMethod: undefined,
    propertyRequired: false,
    propertyDisplay: undefined,
    propertyId: null,
    enableDisplayAvailableStockOption: false,
    enableDisplayAHRIFilter: false,
    payeeOperationInCountry: undefined,
};
